import React, {useEffect, useMemo, useState} from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';

import {Stepper} from './Stepper';

export const WeekStepper = ({startDate, onWeekChanged, canGoBack, canGoForward, locale, userpilot, cy}) => {
	const initialDate = useMemo(() => {
		const initDate = startDate ? startDate : moment();
		if (locale) {
			initDate.locale(locale);
		}
		return initDate;
	}, []);

	const [selectedWeek, setSelectedWeek] = useState(() => ({
		startDate: initialDate.clone().startOf('week'),
		endDate: initialDate.clone().endOf('week'),
	}));

	useEffect(() => {
		if (onWeekChanged) {
			onWeekChanged(selectedWeek);
		}
	}, [selectedWeek]);

	const prevWeek = () => {
		const newEndDate = selectedWeek.startDate.clone().subtract(1, 'day');
		const newStartDate = newEndDate.clone().startOf('week');
		setSelectedWeek({
			startDate: newStartDate,
			endDate: newEndDate,
		});
	};
	const nextWeek = () => {
		const newStartDate = selectedWeek.endDate.clone().add(1, 'day');
		const newEndDate = newStartDate.clone().endOf('week');
		setSelectedWeek({
			startDate: newStartDate,
			endDate: newEndDate,
		});
	};

	return (
		<Stepper
			width={110}
			onForward={nextWeek}
			onBack={prevWeek}
			canNavigateBack={canGoBack}
			canNavigateForward={canGoForward}
			userpilot={userpilot}
			cy={cy}
		>
			{`${selectedWeek.startDate.format('DD MMM')} - ${selectedWeek.endDate.format('DD MMM')}`}
		</Stepper>
	);
};

WeekStepper.propTypes = {
	/**
	 * Set what week to select to begin with. The date should be within the week and be a moment date.
	 * Defaults to current week.
	 */
	startDate: PropTypes.object,
	onWeekChanged: PropTypes.func,
	canGoBack: PropTypes.bool,
	canGoForward: PropTypes.bool,
	/**
	 * Override the global locale for this specific instance. Shouldn't have to be used and is currently primarily used
	 * for demo purposes.
	 */
	locale: PropTypes.object,
	/**
	 * ID needed for on-boarding tool
	 */
	userpilot: PropTypes.string,
	/**
	 * ID needed for Cypress testing
	 */
	cy: PropTypes.string,
};

WeekStepper.defaultTypes = {
	canGoBack: true,
	canGoForward: true,
};
